import React from 'react';
import DateAdapter from '@mui/lab/AdapterMoment';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from './DatePicker';
import Calendar from './Calendar';
import TimePicker from './TimePicker';

const CalendarIndex = (props) => (
	<LocalizationProvider dateAdapter={DateAdapter}>
		<Calendar
			{...props}
		/>
	</LocalizationProvider>
);

const DatePickerIndex = (props) => (
	<LocalizationProvider dateAdapter={DateAdapter}>
		<DatePicker
			{...props}
		/>
	</LocalizationProvider>
);

const TimePickerIndex = (props) => (
	<LocalizationProvider dateAdapter={DateAdapter}>
		<TimePicker
			{...props}
		/>
	</LocalizationProvider>
);

export {
	CalendarIndex,
	DatePickerIndex,
	TimePickerIndex
};

export default DatePickerIndex;
